module.exports.subcategoryOptions = [
  { label: 'Games', key: 'games', category: 'startup' },
  { label: 'DEX', key: 'dex', category: 'startup' },
  { label: 'DePIN', key: 'depin', category: 'startup' },
  { label: 'Tools', key: 'tools', category: 'startup' },
  { label: 'Payment', key: 'payment', category: 'startup' },
  { label: 'Infrastructure/Development', key: 'infrastructureDevelopment', category: 'startup' },
  { label: 'Wallets', key: 'wallets', category: 'startup' },
  { label: 'Trading', key: 'trading', category: 'startup' },
  { label: 'NFTs', key: 'nfts', category: 'startup' },
  { label: 'RWA', key: 'rwa', category: 'startup' },
  { label: 'Other', key: 'startupOther', category: 'startup' },

  { label: 'Regulatory', key: 'regulatoryLegal', category: 'legal' },
  { label: 'Data', key: 'data', category: 'legal' },
  { label: 'IP/Brand protection', key: 'ipBrandprotection', category: 'legal' },
  { label: 'Corporate', key: 'corporate', category: 'legal' },
  { label: 'Litigation', key: 'litigation', category: 'legal' },
  { label: 'Environmental', key: 'environmental', category: 'legal' },
  { label: 'Commercial/Contract', key: 'commercialContract', category: 'legal' },
  { label: 'Asset recovering', key: 'assetRecovering', category: 'legal' },
  { label: 'Insolvency', key: 'insolvency', category: 'legal' },
  { label: 'Crossborder', key: 'crossborder', category: 'legal' },
  { label: 'Policies', key: 'policiesLegal', category: 'legal' },
  { label: 'Court Representation', key: 'courtRepresentation', category: 'legal' },
  { label: 'Other', key: 'legalOther', category: 'legal' },

  { label: 'Accounting Software', key: 'accountingSoftware', category: 'accounting' },
  { label: 'Gain & Loss calculation', key: 'gainLossCalculation', category: 'accounting' },
  { label: 'Reconciliation', key: 'reconciliation', category: 'accounting' },
  { label: 'Fair market valuation', key: 'fairMarketValuation', category: 'accounting' },
  { label: 'Auditing', key: 'auditing', category: 'accounting' },
  { label: 'Wallet ownership', key: 'walletOwnership', category: 'accounting' },
  { label: 'Company projection', key: 'companyProjection', category: 'accounting' },
  { label: 'NFT Valuation', key: 'nftValuation', category: 'accounting' },
  { label: 'VAT', key: 'vat', category: 'accounting' },
  { label: 'Structuring', key: 'structuring', category: 'accounting' },
  { label: 'Tax investigation', key: 'taxInvestigation', category: 'accounting' },
  { label: 'Other', key: 'accountingOther', category: 'accounting' },

  { label: 'Community Building', key: 'communityBuilding', category: 'marketing' },
  { label: 'Social Media', key: 'socialMedia', category: 'marketing' },
  { label: 'Content Marketing', key: 'contentMarketing', category: 'marketing' },
  { label: 'Search Engine Optimisation (SEO)', key: 'searchEngineOptimisationSEO', category: 'marketing' },
  { label: 'Email Marketing', key: 'emailMarketing', category: 'marketing' },
  { label: 'Influencer Marketing', key: 'influencerMarketing', category: 'marketing' },
  { label: 'Branding', key: 'branding', category: 'marketing' },
  { label: 'Public Relations', key: 'publicRelations', category: 'marketing' },
  { label: 'Strategic & Policies', key: 'strategicPolicies', category: 'marketing' },
  { label: 'Advertising', key: 'advertising', category: 'marketing' },
  { label: 'Events', key: 'events', category: 'marketing' },
  { label: 'Product Marketing', key: 'productMarketing', category: 'marketing' },
  { label: 'Other', key: 'marketingOther', category: 'marketing' },

  { label: 'Legal consulting', key: 'legalConsulting', category: 'consulting' },
  { label: 'Strategy & Advisory', key: 'strategy&Advisory', category: 'consulting' },
  { label: 'Operation', key: 'operation', category: 'consulting' },
  { label: 'Tech Development & Implementation', key: 'techDevelopment&Implementation', category: 'consulting' },
  { label: 'Security & Auditing', key: 'security&Auditing', category: 'consulting' },
  { label: 'Tokenomics', key: 'tokenomics', category: 'consulting' },
  { label: 'Regulatory', key: 'regulatoryConsulting', category: 'consulting' },
  { label: 'Policies', key: 'policiesConsulting', category: 'consulting' },
  { label: 'Compliance', key: 'compliance', category: 'consulting' },
  { label: 'Finance', key: 'finance', category: 'consulting' },
  { label: 'Banking & Payments', key: 'banking&Payments', category: 'consulting' },
  { label: 'Incident prevention & response', key: 'incidentPrevention&Response', category: 'consulting' },
  { label: 'Other', key: 'consultingOther', category: 'consulting' },

  { label: 'General Liability', key: 'generalLiability', category: 'insurance' },
  { label: 'Directors and Officers Insurance', key: 'directorsAndOfficersInsurance', category: 'insurance' },
  { label: 'Cyber Liability Insurance', key: 'cyberLiabilityInsurance', category: 'insurance' },
  { label: 'Professional Indemnity', key: 'professionalIndemnity', category: 'insurance' },
  { label: 'Crime and Fidelity Insurance', key: 'crimeAndFidelityInsurance', category: 'insurance' },
  { label: 'Intellectual Property Insurance', key: 'intellectualPropertyInsurance', category: 'insurance' },
  { label: 'Smart Contract Coverage', key: 'smartContractCoverage', category: 'insurance' },
  { label: 'Cold Storage Insurance', key: 'coldStorageInsurance', category: 'insurance' },
  { label: 'DeFi Insurance', key: 'deFiInsurance', category: 'insurance' },
  { label: 'Slashing coverage', key: 'slashingCoverage', category: 'insurance' },
  { label: 'Technology Errors and Omissions', key: 'technologyErrorsAndOmissions', category: 'insurance' },
  { label: 'Other', key: 'insuranceOther', category: 'insurance' },

  { label: 'Specify the category', key: 'otherOther', category: 'other' },

  // { label: 'Software', key: 'software', category: 'taxation' },
  // { label: 'Accounting', key: 'accounting', category: 'taxation' },

  // { label: 'Company registration', key: 'comapnyReistration', category: 'consultancy' },
  // { label: 'Tokenomics', key: 'tokenomics', category: 'consultancy' },
  // { label: 'General', key: 'general', category: 'consultancy' },

  // { label: 'Trading', key: 'trading', category: 'infrastructure' },
  // { label: 'Exchange', key: 'exchange', category: 'infrastructure' },
  // { label: 'Token', key: 'token', category: 'infrastructure' },
  // { label: 'Data', key: 'data', category: 'infrastructure' },
  // { label: 'DAO', key: 'dao', category: 'infrastructure' },

  // { label: 'Funds', key: 'funds', category: 'structuring' },
  // { label: 'ETF', key: 'etf', category: 'structuring' },
  // { label: 'Certificates', key: 'certificates', category: 'structuring' },
  // { label: 'Indices', key: 'indices', category: 'structuring' },
  // { label: 'Trust', key: 'trust', category: 'structuring' },

  { label: 'AML', key: 'aml', category: 'compliance' },
  { label: 'KYC', key: 'kyc', category: 'compliance' },
  { label: 'Travel Rule', key: 'traverRule', category: 'compliance' },
  { label: 'Transaction Monitoring', key: 'transactionMonitoring', category: 'compliance' },
  { label: 'Regulation', key: 'regulation', category: 'compliance' },
  { label: 'Compliance as a service', key: 'complianceAsAService', category: 'compliance' },
  { label: 'Other', key: 'complianceOther', category: 'compliance' },

  { label: 'C-Suite', key: 'CSuite', category: 'recruiting' },
  { label: 'Board and Advisory', key: 'boardAndAdvisory', category: 'recruiting' },
  { label: 'Sales and Partnerships', key: 'salesAndPartnerships', category: 'recruiting' },
  { label: 'Finance and Accounting', key: 'financeAndAccounting', category: 'recruiting' },
  { label: 'Marketing and Community', key: 'marketingAndCommunity', category: 'recruiting' },
  { label: 'Operations & Administration', key: 'operationsAdministration', category: 'recruiting' },
  { label: 'Product and Engineering', key: 'productAndEngineering', category: 'recruiting' },
  { label: 'Legal and Compliance', key: 'legalAndCompliance', category: 'recruiting' },
  { label: 'Trading', key: 'trading', category: 'recruiting' },
  { label: 'Investor Relations and Fundraising', key: 'investorRelationsAndFundraising', category: 'recruiting' },
  { label: 'HR & Talent', key: 'HRTalent', category: 'recruiting' },
  { label: 'Research', key: 'recruitingResearch', category: 'recruiting' },
  { label: 'Other', key: 'recruitingOther', category: 'recruiting' },

  { label: 'Research', key: 'educationResearch', category: 'education' },
  { label: 'Compliance Courses', key: 'complainceCourses', category: 'education' },
  { label: 'Accounting Courses', key: 'accountingCourses', category: 'education' },
  { label: 'Other', key: 'educationOther', category: 'education' },

  { label: 'Cyber Security', key: 'cyberSecurity', category: 'riskSecurity' },
  { label: 'Auditing', key: 'auditing', category: 'riskSecurity' },
  { label: 'Risk Monitoring', key: 'riskMonitoring', category: 'riskSecurity' },
  { label: 'Asset Protection', key: 'assetProtection', category: 'riskSecurity' },
  { label: 'Other', key: 'riskSecurityOther', category: 'riskSecurity' },

  { label: 'Technology Consultant', key: 'technologyConsultant', category: 'softwareDevelopment' },
  { label: 'Blockchain Developer/Engineer Layer 1', key: 'blockchainDeveloperEngineerLayer1', category: 'softwareDevelopment' },
  { label: 'Blockchain Developer/Engineer Defi', key: 'blockchainDeveloperEngineerDefi', category: 'softwareDevelopment' },
  { label: 'Blockchain Developer/Engineer NFT', key: 'blockchainDeveloperEngineerNFT', category: 'softwareDevelopment' },
  { label: 'Blockchain Developer/Engineer Metaverse', key: 'blockchainDeveloperEngineerMetaverse', category: 'softwareDevelopment' },
  { label: 'Dabs Developer', key: 'dabsDeveloper', category: 'softwareDevelopment' },
  { label: 'Smart Contract Developer', key: 'smartContractDeveloper', category: 'softwareDevelopment' },
  { label: 'Cryptographer', key: 'cryptographer', category: 'softwareDevelopment' },
  { label: 'Blockchain Architect', key: 'blockchainArchitect', category: 'softwareDevelopment' },
  { label: 'DevOps Engineer', key: 'devOpsEngineer', category: 'softwareDevelopment' },
  { label: 'Backend Developer', key: 'backendDeveloper', category: 'softwareDevelopment' },
  { label: 'Frontend Developer', key: 'frontendDeveloper', category: 'softwareDevelopment' },
  { label: 'UI/UX Designer', key: 'UIUXDesigner', category: 'softwareDevelopment' },
  { label: 'Quality Assurance (QA) Engineer', key: 'qualityAssuranceQAEngineer', category: 'softwareDevelopment' },
  { label: 'Data Scientist/Blockchain Analyst', key: 'dataScientistBlockchainAnalyst', category: 'softwareDevelopment' },
  { label: 'Product Manager', key: 'productManager', category: 'softwareDevelopment' },
  { label: 'Other', key: 'softwareDevelopmentOther', category: 'softwareDevelopment' },
];

module.exports.categoryOptions = [
  { label: 'Startup', key: 'startup' },
  { label: 'Legal', key: 'legal' },
  { label: 'Accounting', key: 'accounting' },
  { label: 'Marketing', key: 'marketing' },
  { label: 'Consulting', key: 'consulting' },
  { label: 'Insurance', key: 'insurance' },
  // { label: 'Taxation', key: 'taxation' },
  // { label: 'Consultancy', key: 'consultancy' },
  // { label: 'Infrastructure', key: 'infrastructure' },
  // { label: 'Investigation', key: 'investigation' },
  // { label: 'Structuring', key: 'structuring' },
  { label: 'Compliance', key: 'compliance' },
  { label: 'Recruiting', key: 'recruiting' },
  { label: 'Education', key: 'education' },
  { label: 'Risk & Security', key: 'riskSecurity' },
  { label: 'Investigation', key: 'investigation' },
  { label: 'Software development', key: 'softwareDevelopment' },
  { label: 'Other', key: 'other' },
];
